<template>
  <!-- 开票详情弹窗组件 -->
  <dialogModel
    :visible="visible"
    title="开票详情"
    width="700px"
    :footer="false"
    :close-on-click-modal="false"
    @handleClose="handleClose"
  >
    <div class="detail-body">
      <div class="section-title">基础信息</div>
      <div class="detail-item">
        <div class="label">订单ID：</div>
        <div class="value">{{ detailInfo.orderNum || '-' }}</div>
      </div>
      <div class="detail-item">
        <div class="label">消费类型：</div>
        <div class="value">{{ getConsumptionTypeName(detailInfo.consumptionType) || '-' }}</div>
      </div>
      <div class="detail-item">
        <div class="label">服务内容：</div>
        <div class="value">{{ detailInfo.serviceContent || '-' }}</div>
      </div>
      <div class="detail-item">
        <div class="label">发票总额（元）：</div>
        <div class="value">{{ detailInfo.total || '-' }}</div>
      </div>
      <div class="detail-item">
        <div class="label">发票类型：</div>
        <div class="value">{{ detailInfo.attributeName || '-' }}</div>
      </div>
      <div class="detail-item">
        <div class="label">发票性质：</div>
        <div class="value">{{ detailInfo.typeName || '-' }}</div>
      </div>
      <div class="detail-item">
        <div class="label">邮箱（发送）：</div>
        <div class="value">{{ mailDisplay }}</div>
      </div>
      <!-- <div class="detail-item">
        <div class="label">地址：</div>
        <div class="value">{{ addressDisplay }}</div>
      </div> -->
      <div class="detail-item">
        <div class="label">订单时间：</div>
        <div class="value">{{ detailInfo.orderTime || '-' }}</div>
      </div>
      <div class="detail-item">
        <div class="label">申请时间：</div>
        <div class="value">{{ detailInfo.applyTime || '-' }}</div>
      </div>
      <div class="detail-item" v-if="detailInfo.note">
        <div class="label">驳回原因：</div>
        <div class="value">{{ detailInfo.note }}</div>
      </div>
      <div class="detail-item">
        <div class="label">发票状态：</div>
        <div class="value">{{ detailInfo.statusName || '-' }}</div>
      </div>

      <div class="section-title">购买方信息</div>
      <div class="detail-item">
        <div class="label">发票抬头：</div>
        <div class="value">{{ detailInfo.headVo?.headName || '-' }}</div>
      </div>
      <div class="detail-item">
        <div class="label">统一社会信用代码：</div>
        <div class="value">{{ detailInfo.headVo?.creditCode || '-' }}</div>
      </div>
      <div class="detail-item">
        <div class="label">开户行名称：</div>
        <div class="value">{{ detailInfo.headVo?.bankName || '-' }}</div>
      </div>
      <div class="detail-item">
        <div class="label">开户行账号：</div>
        <div class="value">{{ detailInfo.headVo?.bankAccount || '-' }}</div>
      </div>
      <div class="detail-item">
        <div class="label">地址：</div>
        <div class="value">{{ detailInfo.headVo?.registerAddress || '-' }}</div>
      </div>
      <div class="detail-item">
        <div class="label">电话：</div>
        <div class="value">{{ detailInfo.headVo?.phone || '-' }}</div>
      </div>
      <div class="detail-item">
        <div class="label">是否隐藏：</div>
        <div class="value">{{ detailInfo.showFlag == 1 ? '是' : '否' }}</div>
      </div>
      <div class="detail-item" v-if="detailInfo.status == 1 && detailInfo.renewReason">
        <div class="label">重开原因：</div>
        <div class="value">{{ detailInfo.renewReason }}</div>
      </div>

      <div class="section-title">销售方信息</div>
      <div class="detail-item">
        <div class="label">企业名称：</div>
        <div class="value">{{ detailInfo.sellerName || '-' }}</div>
      </div>
      <div class="detail-item">
        <div class="label">统一社会信用代码：</div>
        <div class="value">{{ detailInfo.sellerCreditCode || '-' }}</div>
      </div>
      <div class="detail-item">
        <div class="label">地址：</div>
        <div class="value">{{ detailInfo.sellerAddress || '-' }}</div>
      </div>
      <div class="detail-item">
        <div class="label">开户行名称：</div>
        <div class="value">{{ detailInfo.sellerBankName || '-' }}</div>
      </div>
      <div class="detail-item">
        <div class="label">开户行账号：</div>
        <div class="value">{{ detailInfo.sellerBankAccount || '-' }}</div>
      </div>
      <div class="detail-item">
        <div class="label">电话：</div>
        <div class="value">{{ detailInfo.sellerPhone || '-' }}</div>
      </div>
    </div>
  </dialogModel>
</template>

<script>
import dialogModel from "@/components/dialogModel.vue";
import { getInvoiceAuditInfo } from "../../../../../assets/api/firm/firmCenter";

export default {
  components: {
    dialogModel,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    detailId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      detailInfo: {},
    };
  },
  computed: {
    addressMailVo() {
      return this.detailInfo.addressMailVo || {};
    },
    // 电子发票展示邮箱；未发送时仍展示已选邮箱
    mailDisplay() {
      const mail = this.addressMailVo.mail;
      if (mail) return mail;
      return "-";
    },
    // 纸质发票展示邮寄地址
    addressDisplay() {
      const address = this.addressMailVo.address;
      if (address) return address;
      return "-";
    },
  },
  watch: {
    visible(val) {
      if (val && this.detailId) {
        this.getDetail();
      }
      if (!val) {
        this.detailInfo = {};
      }
    },
  },
  methods: {
    handleClose() {
      this.$emit("update:visible", false);
      this.$emit("handleClose");
    },
    getConsumptionTypeName(type) {
      const typeMap = {
        0: '道具',
        1: '代理服务',
        2: '充值',
        3: '增值',
        4:'广告服务'
      };
      return typeMap[type] || '-';
    },
    async getDetail() {
      try {
        const data = {
          data: {
            id: this.detailId,
          },
        };
        const res = await getInvoiceAuditInfo(data);
        if (res.code == 0) {
          this.detailInfo = res.data;
        }
      } catch (error) {
        console.error("获取开票详情失败", error);
      }
    },
  },
};
</script>

<style scoped lang="less">
.detail-body {
  padding: 0 100px;
  box-sizing: border-box;
  .section-title {
    font-size: 16px;
    font-weight: 600;
    color: #333333;
    margin: 20px 0 15px 0;
    padding-bottom: 8px;
    border-bottom: 1px solid #eeeeee;
    text-align: center;
  }
  .section-title:first-child {
    margin-top: 0;
  }
  .detail-item {
    display: flex;
    margin-bottom: 15px;
    .label {
      width: 130px;
      color: #666666;
      font-size: 14px;
      flex-shrink: 0;
      text-align: right;
    }
    .value {
      color: #333333;
      font-size: 14px;
      flex: 1;
      margin-left: 10px;
    }
  }
}
</style>
